import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { filter, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormControl, Validators } from '@angular/forms';
import { Authentication } from '../../services/authentication.service';
import { ErrorHandlingService } from '../../services/error-handling.service';
import { NotificationService } from '../../services/notification.service';
import { AccountService } from '../../services/account.service';
import { TitleService } from '../../services/title.service';

@Component({
  standalone: false,
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css'],
})
export class SignUpComponent implements OnInit {
  userName: string;
  userEmail: string;
  userPass: string;
  organization = '';
  isAdd = false;
  @ViewChild('resultModal') resultModal: any;
  closeResult = '';
  emailErrorMessage = '';
  submitMessage = '';
  email_error = false;
  email_verified_error = false;
  termsAndPrivacy = false;
  show_eye = false;

  emailFC = new FormControl('', [Validators.required, Validators.email]);
  nameFC = new FormControl('', [Validators.required]);
  passwordFC = new FormControl('', [Validators.required]);
  organizationFC = new FormControl('', [Validators.required]);

  constructor(
    private authService: Authentication,
    private accountService: AccountService,
    private router: Router,
    private ngxLoader: NgxUiLoaderService,
    private modalService: NgbModal,
    private errorHandlingService: ErrorHandlingService,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute,
    private titleService: TitleService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.setTabTitle();
    });
    if (this.authService.isTokenValid()) {
      this.router.navigate(['automap']);
    }
    this.emailFC.valueChanges.pipe(debounceTime(600), distinctUntilChanged()).subscribe((res) => {
      this.email_error = false;
      this.email_verified_error = false;
      this.emailErrorMessage = '';
    });
  }
  ngOnInit(): void {
    this.setTabTitle();
  }
  setTabTitle() {
    this.titleService.setTitle(this.activatedRoute.snapshot, this.router.routerState.snapshot);
  }
  onSubmit() {
    this.isAdd = true;
    this.userName = this.nameFC.value;
    this.userEmail = this.emailFC.value;
    this.userPass = this.passwordFC.value;
    this.organization = this.organizationFC.value;

    //this.validateEmail(); not sure if there are any api calls to check if the email is in use
    const email = this.userEmail;
    const re = /\S+@\S+\.\S+/;
    const valid = re.test(email);
    if (email.length > 0 && (valid == null || valid === false)) {
      this.errorHandlingService.showError('Email is invalid');
      this.emailErrorMessage = 'Email is invalid';
      this.email_error = true;
      this.emailFC.setErrors({ incorrect: true });
      return;
    }
    if (!this.termsAndPrivacy || !this.organization || !this.userEmail || !this.userName || !this.userPass) {
      this.errorHandlingService.showError('Please fill the missing fields');
      return;
    }
    this.ngxLoader.start();
    this.accountService
      .signUp(this.userName.toLowerCase(), this.userEmail, this.organization === '' ? null : this.organization, this.userPass)
      .subscribe(
        (data) => {
          this.ngxLoader.stop();
          this.notificationService.showSuccess('A request to create an account has been submitted successfully');
          this.router.navigate(['/signup-success']);
        },
        (err) => {
          this.ngxLoader.stop();
          if (err.error?.status === 417 || err.status === 417) {
            this.email_verified_error = true;
            this.emailFC.setErrors({ incorrect: true });
            this.emailErrorMessage = err.error?.message;
          }
        },
      );
  }

  resendVerificationEmail(): any {
    this.ngxLoader.start();
    this.userName = this.emailFC.value;
    this.accountService.resendVerificationEmail(this.userName.toLowerCase()).subscribe(
      (data) => {
        this.ngxLoader.stop();
        this.notificationService.showSuccess('Verification email resent to ' + this.userName);
      },
      (err) => {
        this.ngxLoader.stop();
        return this.errorHandlingService.handleError(err, err.url);
      },
    );
  }

  openModal() {
    this.modalService.open(this.resultModal, { ariaLabelledBy: 'modal-title' }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed `;
      },
    );
  }

  navigate() {
    window.location.href = 'https://www.terminologyhub.com/automap';
  }

  showPassword(show) {
    this.show_eye = show;
  }
}
